<template>
    <div class="animated fadeIn screening personPage withTabs">
        <b-row>
            <b-col sm="9">
                <b-tabs class="screening__tabs" v-model="tabIndex">
                    <b-tab title="Introduction" :disabled="disabledIntroTab">
                        <b-card>
                            <h4 class="screening__header screening__header--center">
                                Louisiana Child and Youth Sex Trafficking Identification Tool
                            </h4>
                            <p class="screening__description">
                                The purpose of this tool is to support the identification of children and youth (under 21 years old) who may be victims of sex trafficking.
                            </p>
                            <p class="screening__description">
                                <b>
                                    Instructions:
                                </b>
                                <span>
                                    This tool is to be used as a narrative assessment. <b>The indicators outlined in the tool should not be asked directly to the child/youth</b>. To determine if a child or youth may be a victim of sex trafficking, <b>please complete the tool in its entirety</b>. Regardless of the tool's findings, if you have any suspicion or concern of sex trafficking involving a child, please make a report to the <a target="_blank" href="#">DCFS</a> Child Abuse/Neglect Hotline at 855-452-5437. <i>For the complete instructions, please refer to the <a target="_blank" href="https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/Supplementary.User.Guide_LSTTpdf.1.pdf">Supplementary User Guide</a></i>.
                                </span>
                            </p>

                            <p class="screening__description">For questions regarding this tool, please contact the Governor's Office of Human Trafficking Prevention at <a href="mailto:humantrafficking@la.gov">humantrafficking@la.gov</a>.</p>
                        <br>
                            <h4 class="screening__description">Pre-Screening Criteria</h4>
                            <p class="screening__description">To ensure that the the Louisiana Child and Youth Sex Trafficking Identification Tool is implemented consistently, select the screening criteria that applies to the child/youth.</p>

                            <div class='prelimDiv' style="paddingLeft: 1.45em">
                                <b-form-group
                                    :disabled="isTraffickingScreeningCreated"
                                    label-size='lg'
                                    label-class='bold'
                                    label=''
                                >
                                    <div 
                                        v-for="[key, value] of Object.entries(prelimFields['Main'])"
                                        :key="key"
                                    >
                                        <b-form-radio
                                            v-model="prelimRadioConditionalModel"
                                            :value='key'
                                            name="prelimMainSelection"
                                            class='radioCheckbox'
                                        >
                                            {{ value.desc }}
                                            <div v-if="key === 'prelim_selective' && traffickingScreening['prelim_selective'] === true">
                                                <b-form-checkbox
                                                    size="lg"
                                                    v-for="[sKey, sValue] of Object.entries(prelimFields['Selective'])"
                                                    :key="sKey"
                                                    v-model="traffickingScreening[sKey]"
                                                    :class="{'bold': sValue.boldDesc}"
                                                >
                                                    {{ sValue.desc }}
                                                </b-form-checkbox>
                                                <span v-show='prelimSelectiveOptionsError && traffickingScreening[key]' class="text-info">
                                                    Selecting a selective screening criteria is required.
                                                </span>
                                            </div>

                                            <div v-if="value.type === 'other'">
                                                <b-form-textarea
                                                    v-if="traffickingScreening[key]"
                                                    :data-vv-name="value.textVar"
                                                    v-validate="'required'"
                                                    data-vv-as="Other"
                                                    :id="value.textVar"
                                                    :name="value.textVar"
                                                    class="screening__form-input"
                                                    v-model="traffickingScreening[value.textVar]"
                                                    :maxlength="255"
                                                />
                                                <span
                                                    v-show="inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                    class="text-info"
                                                >
                                                    {{ inputValidationErrors.first(value.textVar) }}
                                                </span>
                                            </div>
                                        </b-form-radio>
                                    </div>
                                </b-form-group>
                            </div>

                            <div
                                v-if="!isExisting"
                                class="screening__button-wrapper button-container"
                            >
                                <b-button
                                    variant="secondary"
                                    @click="cancelModal"
                                >Cancel</b-button>
                                <b-button
                                    variant="primary"
                                    @click="completePrelim"
                                >Next</b-button>
                            </div>
                        </b-card>
                    </b-tab>
                    <b-tab title="Screening" :disabled="disabledScreeningTab">
                        <b-row>
                            <b-col cols="12">
                                <b-tabs :class="{screening__tabs: true, nestedTabs: true,
                                 'fontSize-xs': isTraffickingScreeningCreated, 
                                 'fontSize-m': !isTraffickingScreeningCreated}" v-model="screeningTabIndex">
                            
                                    <b-tab title="Section 1: Commercial Sexual Activity">
                                        <p class="screening__header screening__header--italic">
                                            Has the child/youth ever engaged in sex or sex acts for anything of value?
                                        </p>
                                        <p><i>Items of value may include money, food, a place to stay, drugs, gifts, transportation, or something else. Select all that apply.</i></p>
                                        <div class="screening__form">
                                            <b-form-group
                                            :disabled="isTraffickingScreeningCreated || s1Disabled"
                                                label-size='lg'
                                                label-class='bold'
                                                label='Exploitation Indicators'
                                            >
                                            <p>The child/youth has:</p>
                                                <b-form-checkbox
                                                    size="lg"
                                                    v-for="[key, value] of Object.entries(section1Fields['Exploitation'])"
                                                    :key="key"
                                                    v-model="traffickingScreening[key]"
                                                    :class="{'bold': value.boldDesc}"
                                                >
                                                    {{ value.desc }}
                                                </b-form-checkbox>
                                            </b-form-group>

                                        <b-form-group
                                        :disabled="isTraffickingScreeningCreated"
                                                label-size='lg'
                                                label-class='bold'
                                                label='Vulnerability Indicators'
                                                
                                            >
                                            <p>The child/youth has:</p>
                                                <b-form-checkbox
                                                :disabled="s1Disabled"
                                                    size="lg"
                                                    v-for="[key, value] of Object.entries(section1Fields['Vulnerability']['0'])"
                                                    :key="key"
                                                    v-model="traffickingScreening[key]"
                                                    :class="{'bold': value.boldDesc}"
                                                >
                                                    {{ value.desc }}
                                                </b-form-checkbox>
                                        <br>

                                            <p>The child/youth is:</p>
                                            <div 
                                                v-for="[key, value] of Object.entries(section1Fields['Vulnerability']['1'])"
                                                :key="key"
                                            >
                                                <div v-if="!value.type">
                                                    <b-form-checkbox
                                                    :disabled="!key.includes('no_circumstances') && s1Disabled"
                                                        size="lg"
                                                        v-model="traffickingScreening[key]"
                                                        :class="{'bold': value.boldDesc, 'marginTop32': key.includes('no_circumstances')}"
                                                    >
                                                        {{ value.desc }}
                                                    </b-form-checkbox>
                                                </div>
                                                <div v-if="value.type === 'other'">
                                                    <b-form-checkbox 
                                                    :disabled="s1Disabled"
                                                    size="lg" 
                                                    v-model="traffickingScreening[key]"
                                                    >
                                                        {{ value.desc }}
                                                        <!-- <b-form-input
                                                            v-if="traffickingScreening[key]"
                                                            :data-vv-name="value.textVar"
                                                            v-validate="'required'"
                                                            data-vv-as="Other"
                                                            :id="value.textVar"
                                                            type='text'
                                                            :name="value.textVar"
                                                            size="lg"
                                                            class="screening__form-input"
                                                            v-model="traffickingScreening[value.textVar]"
                                                        /> -->
                                                        <b-form-textarea
                                                            v-if="traffickingScreening[key]"
                                                            :data-vv-name="value.textVar"
                                                            v-validate="'required'"
                                                            data-vv-as="Other"
                                                            :id="value.textVar"
                                                            :name="value.textVar"
                                                            class="screening__form-input"
                                                            v-model="traffickingScreening[value.textVar]"
                                                            :maxlength="255"
                                                        />
                                                        <span
                                                            v-show="inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                            class="text-info"
                                                        >
                                                            {{ inputValidationErrors.first(value.textVar) }}
                                                        </span>
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            </b-form-group> 

                                            <br>
                                            <h4>Section 1 Status: <span :class="[s1StatusClasses, 'fontMatchParent']">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.section_1_status] }}</span></h4>
                                        </div> 
                                    </b-tab>

                                    <b-tab title="Section 2: Perpetrator Actions" :disabled="this.isSection1Checked === false">
                                        <p class="screening__header screening__header--italic">
                                            Has someone facilitated, enticed, or benefitted from the sexual activity of the child/youth?
                                        </p>
                                        <p><i>This may be a parent, family member, friend, employer, or romantic partner. Select all that apply.</i></p>
                                        <div class="screening__form">
                                            <b-form-group
                                            :disabled="isTraffickingScreeningCreated || s2Disabled"
                                                label-size='lg'
                                                label-class='bold'
                                                label='Exploitation Indicators'
                                            >
                                            <p>Someone has:</p>
                                                <b-form-checkbox
                                                    size="lg"
                                                    v-for="[key, value] of Object.entries(section2Fields['Exploitation'])"
                                                    :key="key"
                                                    v-model="traffickingScreening[key]"
                                                    :class="{'bold': value.boldDesc}"
                                                >
                                                    {{ value.desc }}
                                                </b-form-checkbox>
                                            </b-form-group>

                                        <b-form-group
                                        :disabled="isTraffickingScreeningCreated"
                                                label-size='lg'
                                                label-class='bold'
                                                label='Vulnerability Indicators'
                                            >
                                            <p>Someone is:</p>
                                            <div 
                                                v-for="[key, value] of Object.entries(section2Fields['Vulnerability'])"
                                                :key="key"
                                            >
                                                <div v-if="!value.type" >
                                                    <b-form-checkbox
                                                    :disabled="!key.includes('no_circumstances') && s2Disabled"
                                                        size="lg"
                                                        v-model="traffickingScreening[key]"
                                                        :class="{'bold': value.boldDesc, 'marginTop32': key.includes('no_circumstances')}"
                                                    >
                                                        {{ value.desc }}
                                                    </b-form-checkbox>
                                                </div>
                                                <div v-if="value.type === 'other'">
                                                    <b-form-checkbox 
                                                    :disabled="s2Disabled"
                                                    size="lg" 
                                                    v-model="traffickingScreening[key]"
                                                    >
                                                        {{ value.desc }}
                                                        <!-- <b-form-input
                                                            v-if="traffickingScreening[key]"
                                                        :data-vv-name="value.textVar"
                                                            v-validate="'required'"
                                                            data-vv-as="Other"
                                                            :id="value.textVar"
                                                            type='text'
                                                            :name="value.textVar"
                                                            size="lg"
                                                            class="screening__form-input"
                                                            v-model="traffickingScreening[value.textVar]"
                                                        /> -->
                                                        <b-form-textarea
                                                            v-if="traffickingScreening[key]"
                                                            :data-vv-name="value.textVar"
                                                            v-validate="'required'"
                                                            data-vv-as="Other"
                                                            :id="value.textVar"
                                                            :name="value.textVar"
                                                            class="screening__form-input"
                                                            v-model="traffickingScreening[value.textVar]"
                                                            :maxlength="255"
                                                        />
                                                        <span
                                                            v-show="inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                            class="text-info"
                                                        >
                                                            {{ inputValidationErrors.first(value.textVar) }}
                                                        </span>
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            </b-form-group> 
                                            <br>
                                            <p class='fontSize22'><b>Section 2 Status: </b><span :class="s2StatusClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.section_2_status] }}</span></p>
                                        </div> 
                                    </b-tab>

                                    <b-tab title="Section 3: Current Abuse" :disabled="this.isSection1Checked === false || this.isSection2Checked === false">
                                    <p class="screening__header screening__header--italic">Is the child/youth currently experiencing abuse, neglect, or other forms of harm?</p>
                                        <p><i>Please select which types of abuse, neglect, or other forms of harm (from the last 90 days) you have knowledge of or concerns about for this child/youth. Select all that apply</i></p>
                                        <div class="screening__form">
                                            <b-form-group
                                            :disabled="isTraffickingScreeningCreated"
                                                label-size='lg'
                                                label-class='bold'
                                                label='Vulnerability Indicators'
                                            >
                                            <div 
                                                v-for="[key, value] of Object.entries(section3Fields)"
                                                :key="key"
                                            >
                                                <div v-if="!value.type" >
                                                    <b-form-checkbox
                                                    :disabled="!key.includes('no_circumstances') && s3Disabled"
                                                        size="lg"
                                                        v-model="traffickingScreening[key]"
                                                        :class="{'bold': value.boldDesc, 'marginTop32': key.includes('no_circumstances')}"
                                                    >
                                                        {{ value.desc }}
                                                    </b-form-checkbox>
                                                </div>
                                                <div v-if="value.type === 'other'">
                                                    <b-form-checkbox 
                                                    :disabled="s3Disabled"
                                                    size="lg" 
                                                    v-model="traffickingScreening[key]"
                                                    >
                                                        {{ value.desc }}
                                                        <!-- <b-form-input
                                                            v-if="traffickingScreening[key]"
                                                            :data-vv-name="value.textVar"
                                                            v-validate="'required'"
                                                            data-vv-as="Other"
                                                            :id="value.textVar"
                                                            type='text'
                                                            :name="value.textVar"
                                                            size="lg"
                                                            class="screening__form-input"
                                                            v-model="traffickingScreening[value.textVar]"
                                                        /> -->
                                                        <b-form-textarea
                                                            v-if="traffickingScreening[key]"
                                                            :data-vv-name="value.textVar"
                                                            v-validate="'required'"
                                                            data-vv-as="Other"
                                                            :id="value.textVar"
                                                            :name="value.textVar"
                                                            class="screening__form-input"
                                                            v-model="traffickingScreening[value.textVar]"
                                                            :maxlength="255"
                                                        />
                                                        <span
                                                            v-show="inputValidationErrors.has(value.textVar) && traffickingScreening[key]"
                                                            class="text-info"
                                                        >
                                                            {{ inputValidationErrors.first(value.textVar) }}
                                                        </span>
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            </b-form-group> 
                                            <br>
                                            <p class='fontSize22'><b>Section 3 Status: </b><span :class="s3StatusClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.section_3_status] }}</span></p>
                                        </div>
                                    </b-tab>

                                    <b-tab title="Location" :disabled="this.isSection1Checked === false || this.isSection2Checked === false || this.isSection3Checked === false">
                                    <p class="screening__header">
                                            Select Your Sex Trafficking Screening Location and Program:
                                        </p>
                                        <p class="screening__description">
                                            Select the location and program where this Sex Trafficking Screening occurred. If location and program are not selected, it will default to the primary location and program of the organization.
                                        </p>
                                        
                                        <b-form-group
                                            label-size='lg'
                                            label="Location"
                                            label-for="location"
                                            :horizontal='false'
                                        >
                                            <b-form-select
                                                id='location'
                                                v-if="!isTraffickingScreeningCreated"
                                                :options="locationOptions"
                                                v-model="traffickingScreening.location"
                                                placeholder='Select a Location'
                                            >
                                            {{ traffickingScreening.location }}
                                            </b-form-select>
                                            <p v-else class="screening__description">
                                                {{ locationName }}
                                            </p>
                                        </b-form-group>
                                        
                                        <b-form-group
                                            label-size='lg'
                                            label="Program"
                                            label-for="program"
                                            :horizontal='false'
                                        >
                                            <b-form-select
                                                v-if="!isTraffickingScreeningCreated"
                                                id='program'
                                                :options="programOptions"
                                                v-model="traffickingScreening.program"
                                                placeholder='Select a Program'
                                            >
                                                {{ traffickingScreening.program }}
                                            </b-form-select>
                                            <p v-else class="screening__description">
                                                {{ programName }}
                                            </p>
                                        </b-form-group>
                                    </b-tab>
                                    <div
                                        v-if="!isExisting"
                                        class="screening__button-wrapper button-container"
                                    >
                                        <b-button
                                            variant="secondary"
                                            @click.prevent="cancelModal"
                                        >Cancel</b-button>
                                        <b-button
                                            v-if="showPreviousBtn"
                                            variant="outline-primary"
                                            @click.prevent="prevScreeningTab"
                                        >Previous</b-button>
                                        <b-button
                                            v-if="showNextBtn"
                                            variant="primary"
                                            @click.prevent="nextScreeningTab"
                                        >Next</b-button>
                                        <b-button
                                            v-if="showSubmitBtn"
                                            variant="primary"
                                            @click.prevent="submit"
                                        >Submit</b-button>
                                    </div>
                                </b-tabs>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab title="Conclusion" :disabled="disabledConclusionTab">
                        <b-card>
                            <p class='screening__description'><b><i>If the child/youth is in immediate danger or if there is an active safety concern, immediately call 911 and report to law enforcement. Review the User Guide for additional actions and guidance.</i></b></p>
                            <br>
                            <h5 class="screening__header">Summary:</h5>
                            <div class="screening__table">
                                <b-row class="screening__row">
                                    <b-col
                                        class="screening__col"
                                        cols="10"
                                    >
                                        <span>
                                            Section 1: Commercial Sexual Activity
                                        </span>
                                    </b-col>
                                    <b-col
                                        class="screening__col"
                                        cols="2"
                                    >
                                        <b-checkbox :checked="isSection1Checked" disabled />
                                    </b-col>
                                </b-row>
                                <b-row class="screening__row">
                                    <b-col
                                        class="screening__col"
                                        cols="10"
                                    >
                                        <span>
                                            Section 2: Perpetrator Actions
                                        </span>
                                    </b-col>
                                    <b-col
                                        class="screening__col"
                                        cols="2"
                                    >
                                        <b-checkbox :checked="isSection2Checked" disabled />
                                    </b-col>
                                </b-row>
                                <b-row class="screening__row">
                                    <b-col
                                        class="screening__col"
                                        cols="10"
                                    >
                                        <span>
                                        Section 3: Current Abuse
                                        </span>
                                    </b-col>
                                    <b-col
                                        class="screening__col"
                                        cols="2"
                                    >
                                        <b-checkbox :checked="isSection3Checked" disabled />
                                    </b-col>
                                </b-row>
                            </div>
                            <br>
                            <div class="screening__conclusion screening__description">
                                <h5 class="screening__header">Final Screening Results and Actions:</h5>
                                <div v-if="traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.NOT_ENOUGH_INFO">
                                    <!-- <p><b>Not Enough Information</b></p> -->
                                    <h5 :class="conclusionClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.conclusion] }} [Monitor]</h5>
                                    <br>
                                    <p>There is not enough information to determine whether the child/youth is experiencing sex trafficking. <b>Continue to monitor the child/youth</b>; upon learning more information, re-screen the child/youth.</p>
                                </div>

                                <div v-else-if="traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1">
                                    <!-- <p><b>Level 1: Concern</b></p> -->
                                    <h5 :class="conclusionClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.conclusion] }} [Re-Screen]</h5>
                                    <br>
                                    <p>There is concern for possible sex trafficking. If you are a mandatory reporter and have suspicion or knowledge of child abuse (ex: physical or sexual abuse) or neglect (ex: malnourishment), you are required by law to make a mandatory report to DCFS or law enforcement. <b>Screen again in 90 days or upon learning new information</b>. Consider referring the child/youth to additional services as needed and appropriate. Consider utilizing the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team.</p>
                                </div>

                                <div v-else-if="traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2">
                                    <!-- <p><b>Level 1: Indicated</b></p> -->
                                <h5 :class="conclusionClasses">{{ TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[this.traffickingScreening.conclusion] }} [Report]</h5>
                                <br>
                                <p>The child/youth is considered “indicated” for sex trafficking. As a result, this case warrants review by a Louisiana Human Trafficking Regional Care Coordination Team. <b>Immediately call the DCFS Child Abuse/Neglect Hotline at 855-452-5437 (option 4) to report human trafficking involving a child under the age of 18 years old</b>. If the youth is aged 18 years or older, provide them with the National Human Trafficking Hotline at 888-373-7888 and offer to make a referral to a local service provider with expertise in human trafficking. If the suspected victim is an adult with a disability, report also to Adult Protective Services at 800-898-4910. <b>Utilize the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team</b>.</p>
                                </div>
                            </div>
                            <p class="screening__description">
                                <b>
                                    Location:
                                </b>
                                {{ locationName }}
                            </p>
                            <p class="screening__description">
                                <b>
                                    Program:
                                </b>
                                {{ programName }}
                            </p>
                        </b-card>
                    </b-tab>
                </b-tabs>
            </b-col>
            <b-col v-if="isTraffickingScreeningCreated" sm="3">
                <!-- Person Share -->
                <SharePersonList :personId="traffickingScreening.person._id" :personOrganizationOwner="traffickingScreening.person.organizationOwner" />

                <!-- Screening Share Records-->
                <!-- <ShareTraffickingScreeningList
                    :tsId="traffickingScreening._id"
                    :organizationOwner="traffickingScreening.organizationOwner.id"
                    :personId="traffickingScreening.person._id"
                /> -->
                <!--Meta-->
                <b-card no-body :title="traffickingScreening.id">
                    <b-card-header>
                        <b>Meta</b>
                    </b-card-header>
                    <b-card-body>
                        <p class="card-text">
                            <small class="text-muted text-uppercase bold">LA Sex Trafficking Screening ID: </small>
                            <small> {{traffickingScreening.id}} </small>
                        </p>
                        <p class="card-text">
                            <small class="text-muted text-uppercase bold">Person ID</small>
                            <br/>
                            <small>
                            <router-link :to="'/person/' + traffickingScreening.person.id">
                                {{ traffickingScreening.person.id }}
                            </router-link>
                            </small>
                        </p>
                    </b-card-body>
                    <b-list-group flush>
                        <b-list-group-item class="small text-muted">
                            <b>Created At: </b> {{ getCreatedAt() }}
                            <div v-if="_.isObject(traffickingScreening.createdBy)">
                            <b> by: </b> {{ _.get(traffickingScreening, 'createdBy.emailAddress', '') }}
                            </div>
                            <br>
                            <b>Last Updated: </b> {{ getLastUpdateDate() }}
                            <div v-if="_.isObject(traffickingScreening.updatedBy)">
                            <b> by: </b> {{ _.get(traffickingScreening, 'updatedBy.emailAddress', '') }}
                            </div>
                        </b-list-group-item>

                        <b-list-group-item class="small text-muted">
                            <p class="card-text">
                                <small class="text-muted text-uppercase bold">Current Record Owner</small>
                                <br/>
                                <small class="text-muted"><b> by: </b> {{ _.get(traffickingScreening, 'organizationOwner.title') }} </small>
                            </p>
                            </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="screening__wrapper">
            <b-button
                v-if="isTraffickingScreeningCreated"
                type="button"
                variant="primary"
                class="mb-2 mt-2"
                size="md"
                @click="print"
            >
                <span class="button-text">
                    Print
                </span>
            </b-button>
        </b-row>
        <b-modal
            ref='noSelectionModal'
            v-model="showNoSelectionModal"
            v-bind="{
                'centered': true,
                'title': `Sex Trafficking Screening - ${this.noSelectionSection}`,
                'size': 'lg',
                'ok-title': 'Okay',
                'header-bg-variant': 'success',
                'header-text-variant': 'light',
                'class': 'tos-modal',
                'hide-header-close': true,
                'no-close-on-backdrop': true
            }"
            ok-only
        >
        <template #modal-header-close>
      <h4>X</h4>
    </template>
            <p v-if='this.noSelectionSection === "Introduction"'>Please select the pre-screening criteria that applies to the child/youth prior to continuing with the screening.</p>
            <p v-else>If none of these circumstances apply for the youth, please go back and select the I am not aware of these circumstances applying to the youth/child option.</p>
        </b-modal>

        <b-modal
            ref='cancelModal'
            v-model="showCancelModal"
            v-bind="cancelModalProps"
            @cancel="goBackToPersonRecord"
        >
        <template #modal-header-close>
      <h4>X</h4>
    </template>
            <p>
                {{ cancelModalDescription }}
            </p>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { traffickingScreening as TraffickingScreeningModel } from '@/api/models'
import { TRAFFICKING_SCREENING_CONCLUSION_ENUM, TRAFFICKING_SCREENING_PREFIX, TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP } from '@/helpers/enums'
import SharePersonList from '@/components/Person/SharePersonList'
// import ShareTraffickingScreeningList from '@/components/traffickingScreening/ShareTraffickingScreeningList'

const NUM_OF_SCREENING_TABS = 4
const TABS = {
    INTRO: 0,
    SCREENING: 1,
    CONCLUSION: 2
}

export default {
    name: 'AddLASexTraffickingScreening',

    components: {
        SharePersonList
        // ShareTraffickingScreeningList
    },

    beforeRouteLeave (to, from, next) {
        if (this.isExisting) {
            next()
            return
        }

        if (this.isTraffickingScreeningCreated) {
            next()
            return
        }

        if (this.goBackCalled) {
            this.goBackCalled = false
            next()
            return
        }

        this.showCancelModal = true
    },

    inject: ['$validator'],

    props: {
        isExisting: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            tabIndex: TABS.INTRO,
            screeningTabIndex: 0,
            programOptions: [],
            locationOptions: [],
            traffickingScreening: Object.assign({}, TraffickingScreeningModel),
            prelimMainSelection: '',
            prelimSelectiveOptionsError: false,
            showNoSelectionModal: false,
            noSelectionSection: 'Section 1: Commercial Sexual Activity',
            showCancelModal: false,
            cancelModalProps: {
                'centered': true,
                'title': 'Cancel Sex Trafficking Screening',
                'size': 'lg',
                'ok-title': 'No, return to Sex Trafficking Screening',
                'cancel-title': 'Yes, cancel',
                'header-bg-variant': 'success',
                'header-text-variant': 'light',
                'class': 'tos-modal',
                'hide-header-close': true,
                'no-close-on-backdrop': true
            },
            cancelModalDescription: 'Are you sure you want to cancel this Sex Trafficking Screening? The information you entered will not be saved.',
            friendlyPersonId: !this.isExisting ? this.$route.params.id : '',
            friendlyScreeningId: this.isExisting ? this.$route.params.id : '',
            goBackCalled: false,
            s1Disabled: false,
            s2Disabled: false,
            s3Disabled: false,
            TRAFFICKING_SCREENING_CONCLUSION_ENUM,
            TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP
        }
    },

    computed: {
        ...mapGetters({
            traffickingScreeningFields: 'getTraffickingScreeningFields',
            orgPrograms: 'getProgramsByOrg',
            orgLocations: 'getLocationsByOrg',
            userCurrentContext: 'userCurrentContext',
            person: 'getEditPerson',
            currentTraffickingScreening: 'getTraffickingScreening'
        }),

        showPreviousBtn () {
            return this.screeningTabIndex !== 0
        },

        showNextBtn () {
            return this.screeningTabIndex < NUM_OF_SCREENING_TABS - 1
        },

        showSubmitBtn () {
            return this.screeningTabIndex === NUM_OF_SCREENING_TABS - 1
        },

        prelimFields () {
            return this.traffickingScreeningFields['PRELIM']
        },

        section1Fields () {
            return this.traffickingScreeningFields['ONE']
        },

        section2Fields () {
            return this.traffickingScreeningFields['TWO']
        },

        section3Fields () {
            return this.traffickingScreeningFields['THREE']
        },

        locationName () {
            const selectedLocation = this.traffickingScreening.location
             if (!selectedLocation && selectedLocation !== 0) {
                return ''
            }
            if (selectedLocation && selectedLocation.id) {
                return selectedLocation.title
            }
            const option = this.locationOptions.filter((loc) => loc.value === selectedLocation)[0]
            return (option && option.text) || ''
        },

        programName () {
            const selectedProgram = this.traffickingScreening.program
            if (!selectedProgram && selectedProgram !== 0) {
                return ''
            }
            if (selectedProgram && selectedProgram.id) {
                return selectedProgram.title === 'Other' ? selectedProgram.title_otherText : selectedProgram.title
            }
            const option = this.programOptions.filter((program) => program.value === selectedProgram)[0]
            return (option && option.text) || ''
        },

        prelimRadioConditionalModel: {
            // Active form radios need 1 selected name in data and a completed disabled form needs selection from this.traffickingScreening
            get () {
                if (!this.isTraffickingScreeningCreated) {
                    return this.prelimMainSelection
                } else {
                    return Object.keys(this.prelimFields['Main']).find(k => this.traffickingScreening[k] === true)
                }
            },
            set (newValue) {
                if (!this.isTraffickingScreeningCreated) {
                    this.prelimMainSelection = newValue
                }
            }
        },
        checkPrelimSelectiveOptions () {
            if (this.traffickingScreening['prelim_selective']) {
                return Object.keys(this.traffickingScreening)
                    .filter((key) => Object.keys(this.prelimFields['Selective']).includes(key))
                    .reduce((isChecked, key) => isChecked || !!this.traffickingScreening[key], false)
            } else {
                return true
            }
        },
        checkPrelim () {
            if (this.traffickingScreening['prelim_other']) {
                return this.traffickingScreening['prelim_other_text'].length > 0
            } else {
                return this.areFieldsChecked(TRAFFICKING_SCREENING_PREFIX.PRELIM)
            }
        },

        isSection1Checked () {
            return this.areFieldsChecked(TRAFFICKING_SCREENING_PREFIX.ONE)
        },

        isSection2Checked () {
            return this.areFieldsChecked(TRAFFICKING_SCREENING_PREFIX.TWO)
        },

        isSection3Checked () {
            return this.areFieldsChecked(TRAFFICKING_SCREENING_PREFIX.THREE)
        },

        isTraffickingScreeningCreated () {
            return !!this.traffickingScreening._id && !!this.traffickingScreening.id
        },

        disabledIntroTab () {
            return !this.isExisting && (
                this.isTraffickingScreeningCreated || this.tabIndex > TABS.INTRO
            )
        },

        disabledScreeningTab () {
            return !this.isExisting && (
                this.isTraffickingScreeningCreated || (
                    (this.tabIndex <= TABS.INTRO &&
                    this.tabIndex >= TABS.CONCLUSION) ||
                    (!this.checkPrelim || !this.checkPrelimSelectiveOptions)
                )
            )
        },

        disabledConclusionTab () {
            return !this.isExisting && !this.isTraffickingScreeningCreated
        },

        s1StatusClasses () {
            return [
                'screening__description--bold',
                {
                    'text-warning': this.traffickingScreening.section_1_status === '1',
                    'text-danger': this.traffickingScreening.section_1_status === '2'
                }
            ]
        },
        s2StatusClasses () {
            return [
                'screening__description--bold',
                {
                    'text-warning': this.traffickingScreening.section_2_status === '1',
                    'text-danger': this.traffickingScreening.section_2_status === '2'
                }
            ]
        },
        s3StatusClasses () {
            return [
                'screening__description--bold',
                {
                    'text-warning': this.traffickingScreening.section_3_status === '1',
                    'text-danger': this.traffickingScreening.section_3_status === '2'
                }
            ]
        },

        conclusionClasses () {
            return [
                'mb-0',
                'screening__description',
                'screening__description--bold',
                {
                    'text-warning': this.traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1,
                    'text-danger': this.traffickingScreening.conclusion === TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2
                }
            ]
        }
    },

    updated () {
        // Reset prelim selective options error to false when 1 is checked
        if (this.checkPrelimSelectiveOptions) {
            this.prelimSelectiveOptionsError = false
        }

        // Reset 'other text' values if their coresponding 'other' checkbox is unchecked
        ['one', 'two'].forEach(p => { // sections 1 and 2
            if (this.traffickingScreening[`${p}_vul_other`] === false) {
                this.traffickingScreening[`${p}_vul_other_text`] = ''
            }
        });
        ['_other', '_no_certain'].forEach(mp => { // section 3
            if (this.traffickingScreening[`three${mp}`] === false) {
                this.traffickingScreening[`three${mp}_text`] = ''
            }
        })

        // Get section statuses in real time
        // Section 1
        let s1 = this.section1Fields

        let s1ExpHasTrue = Object.keys(this.traffickingScreening)
            .filter((key) => Object.keys(s1['Exploitation']).includes(key))
            .reduce((isChecked, key) => isChecked || !!this.traffickingScreening[key], false)

        let s1VulTrueLength = Object.keys(this.traffickingScreening)
            .filter((key) => Object.keys(s1['Vulnerability']['0']).includes(key) || Object.keys(s1['Vulnerability']['1']).includes(key)).map(nKey => this.traffickingScreening[nKey]).filter(v => v === true).length

        if (this.traffickingScreening.one_no_circumstances === true) {
            this.traffickingScreening.section_1_status = '0'
            Object.keys(s1['Exploitation']).forEach((k) => { this.traffickingScreening[k] = false })
            Object.keys(s1['Vulnerability']['0']).forEach((k) => { this.traffickingScreening[k] = false })
            Object.keys(s1['Vulnerability']['1']).filter(key => !key.includes('no_circumstances')).forEach((k) => { this.traffickingScreening[k] = false })
            this.traffickingScreening.one_vul_other_text = ''
            this.s1Disabled = true
        } else if (s1ExpHasTrue) {
            this.traffickingScreening.section_1_status = '2'
        } else if (s1VulTrueLength >= 2) {
            this.traffickingScreening.section_1_status = '1'
        } else {
            this.traffickingScreening.section_1_status = '0'
            this.s1Disabled = false
        }

        // Section 2
        let s2 = this.section2Fields

        let s2ExpHasTrue = Object.keys(this.traffickingScreening)
            .filter((key) => Object.keys(s2['Exploitation']).includes(key))
            .reduce((isChecked, key) => isChecked || !!this.traffickingScreening[key], false)

        let s2VulTrueLength = Object.keys(this.traffickingScreening)
            .filter((key) => Object.keys(s2['Vulnerability']).includes(key)).map(nKey => this.traffickingScreening[nKey]).filter(v => v === true).length

        if (this.traffickingScreening.two_no_circumstances === true) {
            this.traffickingScreening.section_2_status = this.traffickingScreening.section_1_status
            Object.keys(s2['Exploitation']).forEach((k) => { this.traffickingScreening[k] = false })
            Object.keys(s2['Vulnerability']).filter(key => !key.includes('no_circumstances')).forEach((k) => { this.traffickingScreening[k] = false })
            this.traffickingScreening.two_vul_other_text = ''
            this.s2Disabled = true
        } else if (s2ExpHasTrue) {
            this.traffickingScreening.section_2_status = '2'
        } else if (s2VulTrueLength > 0) {
            this.traffickingScreening.section_2_status = Number(this.traffickingScreening.section_1_status) < 2 ? (Number(this.traffickingScreening.section_1_status) + 1).toString() : '2'
        } else {
            this.traffickingScreening.section_2_status = '0'
            this.s2Disabled = false
        }

        // Section 3
        let s3 = this.section3Fields

        let s3HasTrue = Object.keys(this.traffickingScreening)
            .filter((key) => Object.keys(s3).includes(key))
            .reduce((isChecked, key) => isChecked || !!this.traffickingScreening[key], false)

        if (this.traffickingScreening.three_no_circumstances === true) {
            this.traffickingScreening.section_3_status = this.traffickingScreening.section_2_status
            Object.keys(s3).filter(key => !key.includes('no_circumstances')).forEach((k) => { this.traffickingScreening[k] = false })
            this.traffickingScreening.three_other_text = ''
            this.s3Disabled = true
        } else if (s3HasTrue) {
            // If one or more boxes are checked, increase the screening status of Section 3 by one level.
            if (Number(this.traffickingScreening.section_2_status) < 2) {
            this.traffickingScreening.section_3_status = (Number(this.traffickingScreening.section_2_status) + 1).toString()
            } else {
                this.traffickingScreening.section_3_status = '2'
            }
        } else {
            this.traffickingScreening.section_3_status = '0'
            this.s3Disabled = false
        }
    },

    watch: {
        currentTraffickingScreening (newValue) {
            if (newValue) {
                this.traffickingScreening = newValue
                // this.checkOtherFields()
            }
        },

        prelimMainSelection (newValue) {
            Object.keys(this.prelimFields['Main']).filter(e => e !== newValue).forEach((k) => {
                this.traffickingScreening[k] = false
                if (k.includes('_other')) {
                    this.traffickingScreening[`${k}_text`] = ''
                }
            })
            this.traffickingScreening[newValue] = true

            if (newValue !== 'prelim_selective') {
                Object.keys(this.prelimFields['Selective']).forEach(k => { this.traffickingScreening[k] = false })
                this.prelimSelectiveOptionsError = false
            }
        },

        orgPrograms (newValue) {
            if (newValue) {
                this.setProgramOptions()
                this.setDefaultProgram()
            }
        },

        orgLocations (newValue) {
            if (newValue) {
                this.setLocationOptions()
                this.setDefaultLocation()
            }
        }
    },

    async created () {
        const orgId = _.get(this.userCurrentContext, 'organization.id', false)

        if (this.isExisting) {
            // console.log('friendlyScreeningId', this.friendlyScreeningId)
            await this.$store.dispatch('getTraffickingScreening', {
                id: this.friendlyScreeningId
            })
            this.tabIndex = TABS.CONCLUSION
            return
        }

        this.getOrgProgramsAndLocations(orgId)

        const groupId = _.get(this.userCurrentContext, 'group.id', false)
        const userId = _.get(this.userCurrentContext, 'userMember.muser', false)

        if (this.friendlyPersonId) {
            await this.$store.dispatch('getPersonForEdit', {
                id: this.friendlyPersonId,
                orgId: orgId,
                groupId: groupId
            })
        }
        this.initScreening(userId, orgId)
    },

    beforeDestroy () {
        this.$store.dispatch('initCreateTraffickingScreening')
    },

    methods: {
        getCreatedAt () {
          const traffickingScreening = this.traffickingScreening
          if (traffickingScreening.createdAt && traffickingScreening.createdAt.includes('T')) {
              return this.$utils.formatDate(traffickingScreening.createdAt)
          } else if (traffickingScreening.createdAt) {
              return this.$utils.unixToHuman(traffickingScreening.createdAt / 1000)
          }
        },
        getLastUpdateDate () {
          const traffickingScreening = this.traffickingScreening
          if (traffickingScreening.updatedAt && traffickingScreening.updatedAt.includes('T')) {
              return this.$utils.formatDate(traffickingScreening.updatedAt)
          } else if (traffickingScreening.updatedAt) {
              return this.$utils.unixToHuman(traffickingScreening.updatedAt / 1000)
          }
        },
        goToVictimStatus (item) {
            // console.log(this.traffickingScreening.person)
            this.$router.push({ path: '/person/' + this.traffickingScreening.person.id + '/edit/victiminformation' })
        },
        areFieldsChecked (prefix) {
            return Object.keys(this.traffickingScreening)
                .filter((key) => key.startsWith(prefix))
                .reduce((isChecked, key) => isChecked || !!this.traffickingScreening[key], false)
        },

        goBackToPersonRecord () {
            this.showCancelModal = false
            this.goBackCalled = true
            this.$router.push({
                path: `/person/${this.friendlyPersonId}`
            })
        },

        setProgramOptions () {
            const programs = this.orgPrograms.map((program) => {
                return {
                    text: program.title === 'Other'
                        ? program.title_otherText
                        : program.title,
                    value: program.id
                }
            })
            programs.sort((a, b) => a.text.localeCompare(b.text))
            this.programOptions = programs
        },

        setLocationOptions () {
            const locations = this.orgLocations.map((location) => {
                return {
                    text: location.title === 'Other'
                        ? location.title_otherText
                        : location.title,
                    value: location.id
                }
            })
            locations.sort((a, b) => a.text.localeCompare(b.text))
            this.locationOptions = locations
        },

        setDefaultLocation () {
            const location = this.orgLocations[0]
            const locationId = _.get(this.userCurrentContext, 'organization.defaultLocation', false) ||
                (location && location.id)
            this.traffickingScreening.location = locationId
        },

        setDefaultProgram () {
            const program = this.orgPrograms[0]
            const programId = _.get(this.userCurrentContext, 'organization.defaultProgram', false) ||
                (program && program.id)
            this.traffickingScreening.program = programId
        },

        getOrgProgramsAndLocations (orgId) {
            this.$store.dispatch('getLocationsByOrg', { orgId })
            this.$store.dispatch('getProgramsByOrg', { orgId })
        },

        // checkOtherFields () { // Not needed because I have the other checkboxes in the form model..??
        //     const checkedOtherFields = Object.keys(this.traffickingScreening).filter((key) => key.endsWith('other_text') && !!this.traffickingScreening[key])

        //     checkedOtherFields.forEach((field) => {
        //         const key = field.substring(0, field.length - 4)
        //         this.traffickingScreening[key] = true
        //     })
        // },

        initScreening (userId, orgId) {
            delete this.traffickingScreening._id
            delete this.traffickingScreening.id
            delete this.traffickingScreening.createdAt
            delete this.traffickingScreening.updatedAt

            this.traffickingScreening.createdBy = userId
            this.traffickingScreening.updatedBy = userId
            this.traffickingScreening.organizationCreator = orgId
            this.traffickingScreening.organizationOwner = orgId
            this.traffickingScreening.person = this.person._id
        },

        completePrelim () {
            this.$validator.validate().then(isValidated => {
                if (isValidated) {
                    if (this.checkPrelim) {
                        if (this.checkPrelimSelectiveOptions) {
                            this.prelimSelectiveOptionsError = false
                            this.tabIndex += 1
                            window.scrollTo(0, 0)
                        } else {
                            this.prelimSelectiveOptionsError = true
                        }
                    } else {
                        this.noSelectionSection = 'Introduction'
                        this.showNoSelectionModal = true
                    }
                }
            })
        },

        nextScreeningTab () {
            this.$validator.validate()
                .then((isValidated) => {
                    // console.log(isValidated)
                    if (isValidated) {
                        if (this.screeningTabIndex === 0) {
                            if (this.isSection1Checked) {
                                this.screeningTabIndex += 1
                                window.scrollTo(0, 0)
                            } else {
                                this.noSelectionSection = 'Section 1: Commercial Sexual Activity'
                                this.showNoSelectionModal = true
                            }
                        } else if (this.screeningTabIndex === 1) {
                            if (this.isSection2Checked) {
                                this.screeningTabIndex += 1
                                window.scrollTo(0, 0)
                            } else {
                                this.noSelectionSection = 'Section 2: Perpetrator Actions'
                                this.showNoSelectionModal = true
                            }
                        } else if (this.screeningTabIndex === 2) {
                            if (this.isSection3Checked) {
                                this.screeningTabIndex += 1
                                window.scrollTo(0, 0)
                            } else {
                                this.noSelectionSection = 'Section 3: Current Abuse'
                                this.showNoSelectionModal = true
                            }
                        }
                    }
                })
        },

        prevScreeningTab () {
            this.$validator.validate()
                .then((isValidated) => {
                    if (isValidated) {
                    this.screeningTabIndex -= 1
                }
            })
        },

        cancelModal () {
            this.showCancelModal = true
        },

        _any (obj) {
            return Object.keys(obj)
                .reduce((isAny, key) => isAny || key, false)
        },

//         calcConclusion () {
//              return TRAFFICKING_SCREENING_CONCLUSION_ENUM.NOT_ENOUGH_INFO
// TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1
//             TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2
//         },

        async submit () {
            if (!this.isTraffickingScreeningCreated && this.traffickingScreening) {
                // remove all the excess other fields
                // this.traffickingScreening = Object.keys(this.traffickingScreening)
                //     .reduce((obj, key) => {
                //         if (key.endsWith('other')) {
                //             delete obj[key]
                //         }
                //         return obj
                //     }, this.traffickingScreening)
                this.traffickingScreening.conclusion = this.traffickingScreening.section_3_status
                // console.log('this.traffickingScreening: ', this.traffickingScreening)
                await this.$store.dispatch('createTraffickingScreening', this.traffickingScreening)
                this.$router.push(`/traffickingscreening/${this.traffickingScreening.id}/view/conclusion`)
            }
        },

        print () {
            if (!this.isTraffickingScreeningCreated) {
                return
            }

            this.$router.push({
                path: `/traffickingScreening/${this.traffickingScreening.id}/print`
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.fontSize22 {
    font-size: 22px;
}

.marginTop32 {
    margin-top: 32px;
}

.screening {
    &__header {
        &--italic {
           font-style: italic;
        }

        &--center {
            text-align: center;
        }

        &--underline {
            text-decoration: underline;
        }
    }

    &__description {
        &--bold {
            font-weight: 700;
        }

        &--italic {
            font-style: italic;
        }
    }

    &__button-wrapper {
        display: block;
        text-align: right;
        padding-top: 1em;
    }

    &__form {
        padding: 10px;
    }

    &__form-input {
        // margin-left: 2px;
        // width: auto;
        min-width: 340px;
        max-width: 700px;
        display: block;
    }

    &__table {
        padding: 0 0 24px 24px;
        width: fit-content;
    }

    &__row {
        border: 1px solid #000000;
    }

    &__col {
        padding: 10px 15px;

        &.col-2 {
            border-left: 1px solid #000000;
        }
    }

    &__wrapper {
        padding: 0 15px;
    }
}

.custom-control {
    padding-left: 45px !important;
}

::v-deep .custom-checkbox.b-custom-control-lg .custom-control-label::before {
    top: 50% !important;
}

// .prelimDiv .radioCheckbox {
//     font-size: 1.25em;
//     line-height: 1.75em;
// }
// .prelimDiv .custom-checkbox {
//     font-size: 1em;
//     line-height: 1.5em;
//     margin-bottom: 5px;
// }

</style>


// WEBPACK FOOTER //
// src/views/t1/Admin/TraffickingScreening.vue